/*
 * @Author: czj
 * @Date: 2023-06-27 16:08:10
 * @Description: 
 * @FilePath: \sanshu-report-new\src\utils\auth.js
 */
import Cookies from 'js-cookie';

const ticket = 'ticket_key';
const BaseURL = "base_url";


//ticket
export function getTicket() {
  return Cookies.get(ticket);
}
export function setTicket(t) {
  return Cookies.set(ticket, t)
}
export function removeTicket() {
  return Cookies.remove(ticket)
}


//baseURL
export function getBaseURL() {
  return Cookies.get(BaseURL);
}
export function setBaseURL(t) {
  return Cookies.set(BaseURL, t)
}
export function removeBaseURL() {
  return Cookies.remove(BaseURL)
}







/* 年_月_日_时_分_秒 */
export function getFormattedDateTime() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 使用padStart填充月份
  const day = currentDate.getDate().toString().padStart(2, '0');
  const hour = currentDate.getHours().toString().padStart(2, '0');
  const minute = currentDate.getMinutes().toString().padStart(2, '0');
  const second = currentDate.getSeconds().toString().padStart(2, '0');

  const formattedDateTime = `${year}_${month}_${day}_${hour}_${minute}_${second}`;

  return formattedDateTime;
};



/* 生成颜色-径向颜色 */
/**
 * initialColor:"#FF5733" 初始颜色
 * step：10 步进值，可以是正数或负数
 * direction："increase"; // 或 "decrease"，指定增加或减少颜色
 *  */
export function adjustColor(initialColor, step, direction) {
  // 解析初始颜色
  const initialRGB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(initialColor);
  const r = parseInt(initialRGB[1], 16);
  const g = parseInt(initialRGB[2], 16);
  const b = parseInt(initialRGB[3], 16);

  // 计算新的颜色值
  let newR = r + step;
  let newG = g + step;
  let newB = b + step;

  // 限制颜色值在 0 到 255 之间
  newR = Math.min(255, Math.max(0, newR));
  newG = Math.min(255, Math.max(0, newG));
  newB = Math.min(255, Math.max(0, newB));

  // 将新的颜色值转换为十六进制格式
  const newColor = `#${newR.toString(16)}${newG.toString(16)}${newB.toString(16)}`;

  return newColor;
}

/* 随机颜色 */
export function generateRandomBrightColor() {
  // const randomColor = () => Math.floor(Math.random() * 256);
  const randomColor = () => Math.floor(Math.random() * 156) + 100; // 100-255 范围内的随机数
  const uniqueColors = new Set();
  let color;
  do {
    color = `rgb(${randomColor()}, ${randomColor()}, ${randomColor()})`;
  } while (uniqueColors.has(color));
  uniqueColors.add(color);
  return color;
}


/* 递归处理多层数据结构 */
export function buildTree(data, parentId = null) {
  const tree = [];
  data.forEach(item => {
    if (item.parentId === parentId) {
      const children = buildTree(data, item.id);
      if (children.length > 0) {
        item.children = children;
      }
      tree.push(item);
    }
  });
  return tree;
}
/* 文件流下载 */
export function fileStreamDownload(inputs, name) {
  // 创建 Blob 对象
  const blob = new Blob([inputs], { type: 'application/octet-stream' });
  // 创建下载链接
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  // 设置下载文件名
  downloadLink.download = name;
  // 触发下载
  downloadLink.click();
  // 删除创建的元素
  URL.revokeObjectURL(downloadLink.href);
  downloadLink.remove();
}

/* 文本数据转义 */
export function parseText(text) {
  try {
    // 尝试解析文本，如果解析失败，捕获异常
    const parsedText = JSON.parse(text);
    return parsedText;
  } catch (error) {
    // 解析失败时，替换转义字符为制表符和换行符
    const unescapedText = text.replace(/\\t/g, '\t').replace(/\\n/g, '\n');
    return unescapedText;
  }
};

/* 判断两个对象是否完全一样 */
export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }
  if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
};






// 异步加载文件，支持file协议和http协议
export function loadScript(url, globalVar) {
  return new Promise((resolve, reject) => {
    if (window[globalVar]) {
      // **如果已经加载，直接返回**
      resolve(window[globalVar]);
      return;
    };
    // **创建 <script> 动态加载**
    const script = document.createElement('script');
    script.src = url; // 确保 public 目录下有这个文件
    script.onload = () => resolve(window[globalVar]);
    script.onerror = () => reject(new Error(`加载 ${url} 失败`));
    document.body.appendChild(script);
  });
}